<template>
  <div class="calendar" :class="{inline: inline}">
    <input ref="input" type="text" v-if="!inline"/>
  </div>
</template>

<script>
import Litepicker from 'litepicker'
import 'litepicker/dist/plugins/multiselect'

export default {
  props: {
    disableDates: {
      type: Array
    },
    inline: {
      type: Boolean,
      default: false
    },
    minDate: {
      type: String,
      default: null
    },
    months: {
      type: Number,
      default: 1
    },
    multi: {
      type: Boolean,
      default: false
    },
    range: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: String,
      required: false
    },
    endDate: {
      type: String,
      required: false
    },
    value: {
      required: false
    },
    buttonText: {
      required: false
    }
  },
  data () {
    let value = (!this.range) ?
        this.value :
        {
          from: (this.value && (typeof this.value.from !== 'undefined')) ? this.value.from : null,
          to: (this.value && (typeof this.value.to !== 'undefined')) ? this.value.to : null,
        }

    return {
      current: value,
      litepicker: null,
    }
  },
  computed: {
    mobileMode () {
      return this.$store.getters['isMobile']
    },
    options () {
      let options = {
        element: (this.inline) ? this.$el : this.$refs.input,
        disallowLockDaysInRange: true,
        firstDay: 0
      }

      if (this.inline) {
        options.inlineMode = true
      }

      if (this.range) {
        options.singleMode = false
      } else if (this.multi) {
        options.plugins = ['multiselect']
      }

      if (this.months > 1 && !this.mobileMode) {
        options.numberOfMonths = this.months
      } else {
        options.numberOfMonths = 1
      }
      options.numberOfColumns = this.months

      if (this.minDate) {
        options.minDate = this.minDate
      }

      if (this.disableDates) {
        options.lockDays = this.disableDates
      }

      if (this.startDate) {
        options.startDate = this.startDate
      }

      if (this.endDate && this.range) {
        options.endDate = this.endDate
      }

      if (this.buttonText) {
        options.buttonText = this.buttonText
      }

      return options
    }
  },
  watch: {
    current: {
      handler () {
        this.$emit('input', this.current)
      },
      deep: true,
    },
    disableDates: {
      handler () {
        this.refreshOptions()
      },
      deep: true
    },
    minDate () {
      this.refreshOptions()
    },
    mobileMode () {
      this.refreshOptions()
    },
    value () {
      if (this.range) {
        if (typeof this.value === 'object') {
          this.litepicker.setDateRange(
              (typeof this.value.from !== 'undefined') ? this.value.from : null,
              (typeof this.value.to !== 'undefined') ? this.value.to : null
          )
        } else {
          this.litepicker.setDateRange(null, null)
        }
      } else {
        this.litepicker.setDate(this.value)
      }
    }
  },
  mounted () {
    this.litepicker = new Litepicker(this.options)
    this.litepicker.on('selected', this.updateCurrent)
  },
  methods: {
    refreshOptions () {
      this.litepicker.setOptions(this.options)
    },
    updateCurrent (date1, date2) {
      if (this.range) {
        this.current.from = date1.format('YYYY-MM-DD')
        this.current.to = date2.format('YYYY-MM-DD')
      } else {
        this.current = date1.format('YYYY-MM-DD')
      }
    }
  }
}
</script>
